import * as Yup from 'yup';
import { requiredField } from 'utils/string';
import { t } from 'utils/i18n';
import { SAVE, CascadeReportAction } from 'constants/actions';

export const actions = [{ id: SAVE, title: t(SAVE), show: 'always' }];

export const initialValues = {
  contract: null,
  claimNumber: '',
  claimDate: new Date(),
  openDebt: '',
  action: CascadeReportAction.DOWNLOAD_FILE,
  managerPosition: '',
  managerName: '',
  email: null,
};

export const validationSchema = Yup.object().shape({
  contract: Yup.object()
    .shape({
      id: Yup.string(),
      name: Yup.string(),
    })
    .nullable()
    .required(requiredField('contract')),
  claimNumber: Yup.string().required(requiredField('claimNumber')),
  claimDate: Yup.date().required(requiredField('claimDate')),
  action: Yup.string(),
  managerPosition: Yup.string().required(requiredField('managerPosition')),
  managerName: Yup.string().required(t('requiredManagerName')),
  email: Yup.object()
    .nullable()
    .when('action', {
      is: (value) => value === CascadeReportAction.SEND_EMAIL,
      then: Yup.object().required(t('requiredField')),
    }),
});
